import React from 'react';

interface OwnProps {
  className?: string;
  firstname: string;
  lastname: string;
  companyname?: string;
  street: string;
  address_addition?: string;
  state?: string;
  country: string;
  zip_code: string;
  city: string;
  email?: string;
  phone?: string;
}

type Props = Readonly<OwnProps>;

const Address: React.FC<Props> = ({
  className,
  firstname,
  lastname,
  companyname,
  street,
  address_addition,
  state,
  country,
  zip_code,
  city,
  email,
  phone,
}) => {
  return (
    <address className={className}>
      {firstname} {lastname}
      <br />
      {companyname && (
        <>
          <strong>{companyname}</strong>
          <br />
        </>
      )}
      {street}
      <br />
      {address_addition && (
        <>
          {address_addition}
          <br />
        </>
      )}
      {state && (
        <span>
          {state}
          <br />
        </span>
      )}
      {/* eslint-disable-next-line react/jsx-no-literals */}
      {country}-{zip_code} {city}
      <br />
      {(email || phone) && <br />}
      {email && (
        <>
          {email}
          <br />
        </>
      )}
      {phone && (
        <>
          {phone}
          <br />
        </>
      )}
    </address>
  );
};

export default React.memo(Address);
